import { SwapOutlined } from "@ant-design/icons"
import { useCallback, useRef } from "react"

import { classAtoms } from "#atoms"
import ButtonToggleModal from "#blocks/ButtonToggleModal"
import SwitchClassModal, {
  SwitchClassModalRef,
} from "#components/forms/AddStudent/SwitchClassModal"
import { ClassConstructor } from "#customTypes/composedTypes/classTypes"
import { DOC_TYPES } from "#customTypes/composedTypes/firebaseTypes"
import { useOneDoc } from "#hooks/jotai/useSubscription"

const SwitchClassButton = ({
  studentId,
  oldClassId,
  isAssistant,
}: {
  studentId: string
  oldClassId: string
  isAssistant: boolean
}) => {
  const modalRef = useRef<SwitchClassModalRef>(null)

  const oldClassObj = useOneDoc<ClassConstructor>(
    classAtoms,
    DOC_TYPES.CLASSES,
    oldClassId
  )

  const handleOk = useCallback(async () => {
    await modalRef.current?.submit()
  }, [])

  return (
    <ButtonToggleModal
      tooltip={isAssistant ? "Switch Assistant Class" : "Switch Class"}
      isIcon
      buttonLabel={<SwapOutlined />}
      modalTitle={`Switching ${isAssistant ? "Assistant Class" : "Class"} - ${oldClassObj?.name || ""}`}
      onOk={handleOk}
      width={1200}
    >
      <SwitchClassModal
        ref={modalRef}
        oldClassId={oldClassId}
        studentId={studentId}
        isAssistant={isAssistant}
      />
    </ButtonToggleModal>
  )
}

export default SwitchClassButton
